var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframeView"},[_c('div',{staticClass:"nav-top"},[_c('i',{staticClass:"iconfont icon-zglsfanhui",on:{"click":function($event){return _vm.toIndex()}}}),_vm._v(" 中国律师网 ")]),_c('div',{staticClass:"iframe-content",domProps:{"innerHTML":_vm._s(_vm.introduce)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }